import { render, staticRenderFns } from "./RemasteredDialog.vue?vue&type=template&id=6255b294&scoped=true&"
import script from "./RemasteredDialog.vue?vue&type=script&lang=js&"
export * from "./RemasteredDialog.vue?vue&type=script&lang=js&"
import style0 from "./RemasteredDialog.vue?vue&type=style&index=0&id=6255b294&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6255b294",
  null
  
)

export default component.exports